import { Box, Button, Card, CardBody, Checkbox, CheckboxGroup, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import HtmlToReact from 'html-to-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactSignatureCanvas from 'react-signature-canvas';
import ModalLoading from '../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../helper/utils/navigation.js';
import { waiverEN, waiverID } from '../../mock/waiver.js';
import { doSubmission } from '../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../layout/FormLayoutProvider.jsx';

const HtmlToReactParser = HtmlToReact.Parser;
export default function UserLogin() {
    const { data = {}, email = '', minor = [] } = useSelector((s) => s?.waiver);
    const { t, i18n } = useTranslation();

    const ref = useRef('');

    const [signature, setSignature] = useState('');

    const onEnd = () => {
        const sig = ref?.current?.getTrimmedCanvas().toDataURL('image/png');
        setSignature(sig);
    };

    const [checkbox, setCheckbox] = useState([]);
    const [checkboxSubscribe, setCheckboxSubscribe] = useState('1');
    const onChangeCheckbox = (e) => setCheckbox(e);
    const onChangeCheckBoxSubscribe = (e) => setCheckboxSubscribe(e?.target?.checked);

    const clear = () => {
        ref?.current?.clear();
        setSignature('');
    };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = () => {
        const payloadFromLocalDisk = JSON.parse(localStorage.getItem('payload'));
        const minors = minor.length === 0 ? JSON.parse(localStorage.getItem('minor') ?? '[]') : minor;

        const payload = {
            ...payloadFromLocalDisk,
            signature,
            minor: minors.map((el) => ({ ...el, parentId: data?.phoneNo ?? '' })),
            email: localStorage.getItem('email'),
            isSubscribed: checkboxSubscribe ? '1' : '0',
            dialCode: localStorage.getItem('dialCode'),
            address: localStorage.getItem('address'),
            telp: localStorage.getItem('phone'),
            fullName: localStorage.getItem('fullname'),
            birthDate: localStorage.getItem('birthDate') ?? '',
            city: localStorage.getItem('city') ?? '9999',
            country: localStorage.getItem('country') ?? 'ID',
        };

        dispatch(doSubmission(payload, navigate));
    };

    const handleCancel = () => {
        navigate(urlNavigate('waiver'));
        clear();
        setCheckbox([]);
    };

    const inputHtml = () => {
        let text;
        switch (i18n.language) {
            case 'id':
                text = waiverID;
                break;
            case 'en':
                text = waiverEN;
                break;
            default:
                text = '';
        }
        return text;
    };

    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = htmlToReactParser.parse(inputHtml());

    const { loadingSubmission = false } = useSelector((s) => s?.waiver);

    return (
        <FormLayoutProvider>
            <ModalLoading loading={loadingSubmission} />
            <FormControl>
                <Card style={{ height: '50vh', overflow: 'auto' }}>
                    <CardBody>
                        <div>{reactElement}</div>
                        <div>
                            <CheckboxGroup colorScheme='blue' defaultValue={checkbox} onChange={onChangeCheckbox}>
                                <Stack spacing={[1, 5]} direction={['column']}>
                                    <Checkbox value='1' size='lg'>
                                        {t('disparity')}
                                    </Checkbox>
                                    <Checkbox value='2' size='lg'>
                                        {t('confirm')}
                                    </Checkbox>
                                </Stack>
                            </CheckboxGroup>
                            <Card>
                                <CardBody>
                                    <br />
                                    <FormLabel>{t('sign_here')}</FormLabel>
                                    <Button onClick={clear} isDisabled={signature === ''}>
                                        {t('clear')}
                                    </Button>
                                </CardBody>
                                <ReactSignatureCanvas
                                    backgroundColor='#EEEEEE'
                                    penColor='black'
                                    ref={ref}
                                    onEnd={onEnd}
                                    canvasProps={{
                                        width: 500,
                                        height: 400,
                                        className: 'sigCanvas',
                                    }}
                                />
                            </Card>
                            <Stack spacing={[1, 5]} direction={['column']} mt={4}>
                                <Checkbox value={checkboxSubscribe} size='lg' defaultValue={checkboxSubscribe} defaultChecked onChange={onChangeCheckBoxSubscribe}>
                                    {t('subscribe')}
                                </Checkbox>
                            </Stack>
                        </div>
                    </CardBody>
                </Card>
                <Box style={{ marginTop: '2em' }}>
                    <Stack direction='row' spacing={4}>
                        <Button onClick={handleCancel} width='100%'>
                            {' '}
                            {t('decline')}
                        </Button>
                        <Button width='100%' isDisabled={checkbox.length !== 2 || signature === ''} onClick={handleSubmit}>
                            {t('agree')}
                        </Button>
                    </Stack>
                </Box>
            </FormControl>
        </FormLayoutProvider>
    );
}
